import React from "react";
import MapArea from "./MapArea.jsx";
import Measure from "react-measure";
import MapObjectFilter from "./MapObjectFilter.jsx";
import StatusLegend from "./StatusLegend";
import Sunstudy from "./Sunstudy";
import SunstudyControls from "./SunstudyControls";
import SunstudyControlsMini from "./SunstudyControlsMini";


export default class MapWithSunstudy extends React.Component {
    constructor () {
        super();

        this.isMeasured = false;

        this.state = {
            width: -1,
            height: -1,
            hoverObject: null,
            sunstudioCurrentSlide: null,
            sunstudioCurrentView: null
        };

        this.updateDimensions = this.updateDimensions.bind(this);
        this.onSunstudioSlide = this.onSunstudioSlide.bind(this);
        this.onSunstudioViewChange = this.onSunstudioViewChange.bind(this);
        this.onSunstudyResize = this.onSunstudyResize.bind(this);
        this.onRoomFilterChange = this.onRoomFilterChange.bind(this);
    }

    onRoomFilterChange (rooms) {
        this.props.onRoomFilterChange(rooms);
    }

    updateDimensions (dimensions) {
        const ratio = this.props.map.width / this.props.map.height;

        this.setState({
            mobileView: dimensions.width < 812,
            width: dimensions.width,
            height: dimensions.width / ratio
        });
    }

    componentDidMount () {
        this.onSunstudioViewChange(this.props.sunstudy.views.data[0]);
    }

    componentDidUpdate (prevProps) {
        if (prevProps.map !== this.props.map) {
            console.log('japa');
            this.onSunstudioViewChange(this.props.sunstudy.views.data[0]);
        }
    }

    shouldComponentUpdate (nextProps, nextState) {
        return true;
    }


    onSunstudioViewChange (view) {
        this.setState({
            sunstudioCurrentView: view,
            sunstudioCurrentSlide: view.start_frame
        });
    }

    onSunstudioSlide (n) {
        this.setState({
            sunstudioCurrentSlide: n
        });
    }

    onSunstudyResize (dimensions) {
        this.props.onMapResize(dimensions);
    }

    render () {
        if (!this.props.map || !this.state.sunstudioCurrentView) {
            return null;
        }

        const zoomLevel = this.state.width / this.props.map.width;

        const paths = this.props.map.regions.data.map((area) => {
            const visible = area.object ? this.props.visibleRooms.indexOf(area.object.data['rooms']) > -1 : false;
            const active = area.object ? this.props.hoverObject === area.object || this.props.showAll : false;

            return (
                <MapArea key={area.id} zoomLevel={zoomLevel} area={area}
                         active={active}
                         hoverObject={this.props.hoverObject}
                         hidden={!visible}
                         onMouseEnter={this.props.onAreaMouseEnter}
                         onMouseMove={this.props.onAreaMouseMove}
                         onMouseLeave={this.props.onAreaMouseLeave}
                         onAreaClick={this.props.onAreaClick}/>
            )
        });

        const style = {
            width: this.state.width + 'px',
            height: this.state.height + 'px',
        };

        return (
            <Measure onMeasure={this.updateDimensions}>
                <div className={this.state.height < 0 ? 'cw-map-hide' : ''}>
                    <div className="cw-map-header">
                        <MapObjectFilter objects={this.props.objects}
                                         visibleRooms={this.props.visibleRooms}
                                         roomsChange={this.onRoomFilterChange}/>
                        <StatusLegend objects={this.props.objects}/>
                    </div>

                    <div className="cw-map-wrap">
                        <Sunstudy sunstudy={this.props.sunstudy}
                                  onSunstudyMeasured={this.onSunstudyResize}
                                  currentView={this.state.sunstudioCurrentView}
                                  currentSlide={this.state.sunstudioCurrentSlide}
                                  hoverObject={this.state.hoverObject}
                                  object={this.state.object}
                                  lastClickedObject={this.state.lastClickedObject}
                        />
                        <svg style={style}>
                            {paths}
                        </svg>

                        {this.props.children}
                    </div>

                    {!this.state.mobileView &&
                    <SunstudyControls sunstudy={this.props.sunstudy}
                                      currentView={this.state.sunstudioCurrentView}
                                      currentSlide={this.state.sunstudioCurrentSlide}
                                      onSlide={this.onSunstudioSlide}
                                      onBack={this.props.onBack}
                                      backButton={this.props.backButton}
                                      onToggleShowAll={this.props.onToggleShowAll}
                                      onViewChange={this.onSunstudioViewChange}/>
                    }
                    {this.state.mobileView &&
                    <SunstudyControlsMini sunstudy={this.props.sunstudy}
                                          currentView={this.state.sunstudioCurrentView}
                                          currentSlide={this.state.sunstudioCurrentSlide}
                                          onSlide={this.onSunstudioSlide}
                                          onBack={this.props.onBack}
                                          backButton={this.props.backButton}
                                          onToggleShowAll={this.props.onToggleShowAll}
                                          onViewChange={this.onSunstudioViewChange}/>
                    }

                </div>
            </Measure>)
    }
}



// WEBPACK FOOTER //
// ./src/components/MapWithSunstudy.jsx